const state = {
    name: 'overview'
};
const getters = {
    getView: state => state.name
};
const actions = {
    nameView({ commit }, name) {
        commit('setName', name);
    }
};
const mutations = {
    setName: (state, name) => state.name = name
};

export default {
    state, getters, actions, mutations
}